import _classCallCheck from "D:/BuildAgent02/work/3584ffa7ff58f781/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/BuildAgent02/work/3584ffa7ff58f781/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "D:/BuildAgent02/work/3584ffa7ff58f781/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "D:/BuildAgent02/work/3584ffa7ff58f781/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _assertThisInitialized from "D:/BuildAgent02/work/3584ffa7ff58f781/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "D:/BuildAgent02/work/3584ffa7ff58f781/node_modules/@babel/runtime/helpers/esm/inherits.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import MaskElement from './mask-element.js';
import IMask from '../core/holder.js';
var KEY_Z = 90;
var KEY_Y = 89;

/** Bridge between HTMLElement and {@link Masked} */
var HTMLMaskElement = /*#__PURE__*/function (_MaskElement) {
  _inherits(HTMLMaskElement, _MaskElement);
  /** HTMLElement to use mask on */

  function HTMLMaskElement(input) {
    var _this;
    _classCallCheck(this, HTMLMaskElement);
    _this = _callSuper(this, HTMLMaskElement);
    _this.input = input;
    _this._onKeydown = _this._onKeydown.bind(_assertThisInitialized(_this));
    _this._onInput = _this._onInput.bind(_assertThisInitialized(_this));
    _this._onBeforeinput = _this._onBeforeinput.bind(_assertThisInitialized(_this));
    _this._onCompositionEnd = _this._onCompositionEnd.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(HTMLMaskElement, [{
    key: "rootElement",
    get: function get() {
      var _this$input$getRootNo, _this$input$getRootNo2, _this$input;
      return (_this$input$getRootNo = (_this$input$getRootNo2 = (_this$input = this.input).getRootNode) == null ? void 0 : _this$input$getRootNo2.call(_this$input)) != null ? _this$input$getRootNo : document;
    }

    /** Is element in focus */
  }, {
    key: "isActive",
    get: function get() {
      return this.input === this.rootElement.activeElement;
    }

    /** Binds HTMLElement events to mask internal events */
  }, {
    key: "bindEvents",
    value: function bindEvents(handlers) {
      this.input.addEventListener('keydown', this._onKeydown);
      this.input.addEventListener('input', this._onInput);
      this.input.addEventListener('beforeinput', this._onBeforeinput);
      this.input.addEventListener('compositionend', this._onCompositionEnd);
      this.input.addEventListener('drop', handlers.drop);
      this.input.addEventListener('click', handlers.click);
      this.input.addEventListener('focus', handlers.focus);
      this.input.addEventListener('blur', handlers.commit);
      this._handlers = handlers;
    }
  }, {
    key: "_onKeydown",
    value: function _onKeydown(e) {
      if (this._handlers.redo && (e.keyCode === KEY_Z && e.shiftKey && (e.metaKey || e.ctrlKey) || e.keyCode === KEY_Y && e.ctrlKey)) {
        e.preventDefault();
        return this._handlers.redo(e);
      }
      if (this._handlers.undo && e.keyCode === KEY_Z && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        return this._handlers.undo(e);
      }
      if (!e.isComposing) this._handlers.selectionChange(e);
    }
  }, {
    key: "_onBeforeinput",
    value: function _onBeforeinput(e) {
      if (e.inputType === 'historyUndo' && this._handlers.undo) {
        e.preventDefault();
        return this._handlers.undo(e);
      }
      if (e.inputType === 'historyRedo' && this._handlers.redo) {
        e.preventDefault();
        return this._handlers.redo(e);
      }
    }
  }, {
    key: "_onCompositionEnd",
    value: function _onCompositionEnd(e) {
      this._handlers.input(e);
    }
  }, {
    key: "_onInput",
    value: function _onInput(e) {
      if (!e.isComposing) this._handlers.input(e);
    }

    /** Unbinds HTMLElement events to mask internal events */
  }, {
    key: "unbindEvents",
    value: function unbindEvents() {
      this.input.removeEventListener('keydown', this._onKeydown);
      this.input.removeEventListener('input', this._onInput);
      this.input.removeEventListener('beforeinput', this._onBeforeinput);
      this.input.removeEventListener('compositionend', this._onCompositionEnd);
      this.input.removeEventListener('drop', this._handlers.drop);
      this.input.removeEventListener('click', this._handlers.click);
      this.input.removeEventListener('focus', this._handlers.focus);
      this.input.removeEventListener('blur', this._handlers.commit);
      this._handlers = {};
    }
  }]);
  return HTMLMaskElement;
}(MaskElement);
IMask.HTMLMaskElement = HTMLMaskElement;
export { HTMLMaskElement as default };